<template>
  <div class="reservations" v-bind:class="{'open-alert': !!alert}">
    <RdsAlert
      v-if="!!alert"
      v-bind:title="alert.title"
      v-bind:text="alert.text"
      v-bind:showCancel="false"
      v-on:alertConfirm="onAlertConfirm"
      v-on:onAlertCancel="onAlertCancel"
    ></RdsAlert>
    <div v-bind:class="this.$route.name+'-img'" class="reservation-img"></div>
    <div class="reservation-calendar-body" v-if="!!!selectedDay">
      <h4 v-html="reservationType.cta"></h4>
      <RdsCalendar
        v-on:selectedDay="onSelectedDay"
        class="rds-reservation"
        v-bind:reservations="filteredReservations"
        v-bind:allUsersReservations="filteredAllUsersReservations"
      ></RdsCalendar>
    </div>
    <RdsEditReservation
      v-on:selectedDay="onSelectedDay"
      v-bind:reservations="filteredReservations"
      v-bind:allUsersReservations="filteredAllUsersReservations"
      v-on:reservationAdded="reservationAdded"
      v-on:reservationDeleted="reservationDeleted"
      v-bind:reservationType="reservationType"
      v-bind:selectedDay="selectedDay"
      v-bind:class="this.$route.name+'-reservation'"
      class="rds-reservation reservation-calendar-body"
      v-if="!!selectedDay"
    ></RdsEditReservation>
  </div>
</template>
<script>
import RdsAlert from '../components/RdsAlert';
import RdsCalendar from '../components/RdsCalendar';
import RdsEditReservation from '../components/RdsEditReservation';
// import RestStore from '../stores/RestStore';
import userService from '../services/User.service';
import { eventBus } from '../services/EventBus';
// const store = new RestStore();
import store from '../stores';
export default {
  name: 'reservations',
  components: {
    RdsCalendar,
    RdsEditReservation,
    RdsAlert
  },
  data() {
    return {
      userReservations: [],
      allUsersReservations: [],
      selectedDay: null,
      alert: null,
      lastNavettaReservation: null
    };
  },
  computed: {
    reservationType() {
      const routeName = this.$route.name;
      return reservationTypes[routeName];
    },
    filteredReservations() {
      return this.userReservations.filter(
        r => r.type === this.reservationType.name
      );
    },
    filteredAllUsersReservations() {
      const res = this.allUsersReservations.filter(
        r => r.type === this.reservationType.name
      );
      return res;
    }
  },
  methods: {
    onSelectedDay(e) {
      document.getElementsByClassName('main')[0].scroll(0, 0);
      setTimeout(() => {
        let today = new Date();
        today.setDate(today.getDate() - 1);
        if (!!e.selectedDay && e.selectedDay.getTime() >= today.getTime()) {
          this.selectedDay = e.selectedDay;
          if (this.$route.name !== 'navetta') {
            eventBus.$emit('showBackButton');
          }
        }
      }, 0);
    },
    reservationAdded(data) {
      this.userReservations.push(data);
      if (this.$route.name === 'navetta') {
        this.selectedDay = new Date();
      } else {
        this.selectedDay = null;
      }
      // this.alert = {
      //   title: 'Prenotazione effettuata',
      //   text:
      //     'Grazie per aver prenotato. Riceverai una mail di conferma sulla tua mail aziendale.'
      // };
      this.alert = _getAlert(data, this.$route.name);
      if (this.$route.name === 'navetta') {
        this.lastNavettaReservation = data;
        console.log(data);
      }
      document.getElementsByClassName('main')[0].scroll(0, 0);
      eventBus.$emit('hideBackButton');
    },
    reservationDeleted(data) {
      const reservations = this.userReservations.filter(r => r.id !== data.id);
      this.userReservations = reservations;
      if (this.$route.name !== 'navetta') {
        this.selectedDay = null;
      }

      this.alert = {
        title: 'Prenotazione cancellata',
        text: 'La prenotazione è stata cancellata con successo.'
      };
      document.getElementsByClassName('main')[0].scroll(0, 0);
      eventBus.$emit('hideBackButton');
    },
    backButtonClicked() {
      this.selectedDay = null;
      eventBus.$emit('hideBackButton');
    },
    onAlertConfirm() {
      this.alert = null;
      if (this.$route.name === 'navetta') {
      }
    },
    onAlertCancel() {
      console.log(this.lastNavettaReservation);
    },
    loadPageButtons() {
      eventBus.$emit('showBellButton');
      eventBus.$emit('showDocumentationButton');
      if (this.$route.name === 'navetta') {
        eventBus.$emit('showReportButton');
      }
    }
  },
  mounted() {
    this.loadPageButtons();
    if (this.$route.name === 'navetta') {
      this.selectedDay = new Date();
    }
    store
      .getAll('reservation', 0)
      // .then(response => response.json())
      // .then(response => response.data.Items)
      // .then(data => data.map(_awsObjToModel))
      .then(data => {
        this.allUsersReservations = data;
        return this.allUsersReservations;
      })
      .then(data => data.filter(d => d.userId === userService.user.id))
      .then(data => {
        console.log(data);
        this.userReservations = data;
      });
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Reservation back');
      this.backButtonClicked();
    });
  },
  destroyed() {
    eventBus.$emit('hideBackButton');
    eventBus.$emit('hideDocumentationButton');
    eventBus.$emit('hideReportButton');
    eventBus.$off('backButtonClicked');
  }
};

const reservationTypes = {
  beauty: {
    cta: 'Prenota il tuo momento <span>beauty</span>',
    subtypes: [
      { id: 1, label: 'Make up', price: '10 €' },
      { id: 2, label: 'Massaggio', price: '40 €' },
      { id: 3, label: 'Taglio', price: '10 €' }
    ],
    timeSlots: ['17.00', '18.00', '19.00'],
    name: 'beauty',
    threshold: 1
  },
  navetta: {
    img: require('../assets/images/navetta.svg'),
    cta: 'Prenota il tuo viaggio in <span>navetta!</span>',
    timeSlots: ['08.00', '08.30', '09.00', '17.00', '18.00', '19.00'],
    name: 'navetta',
    threshold: 6
  },
  barbecue: {
    cta: 'Prenota il <span>barbecue</span>',
    timeSlots: ['13.00', '14.00', '17.00', '18.00', '19.00'],
    name: 'beauty',
    threshold: 1
  },
  bike: {
    cta: 'Prenota la tua <span>bicicletta</span>!',
    timeSlots: ['13.00', '14.00', '17.00', '18.00', '19.00'],
    name: 'bike',
    threshold: 1
  },
  palestra: {
    cta: 'Prenota la <span>palestra</span>!',
    timeSlots: ['13.00', '14.00', '17.00', '18.00', '19.00'],
    name: 'palestra',
    threshold: 2
  }
};
function _awsObjToModel(i) {
  let content = i.content;
  content.id = Number(i.id);
  return content;
}
function _getAlert(data, route) {
  let bodyRows = [];
  // const typeTitle = data.type[0].toUpperCase() + data.type.substr(1);
  const typeTitle = data.type;
  const alertTitle = `Prenotazione ${typeTitle}`;
  const date = new Date(data.date);
  const dateString = date
    .toLocaleString('it-it', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
    .replace(/\//g, '.');
  const hourDateString = date.toLocaleString('it-it', {
    hour: '2-digit',
    minute: '2-digit'
  });
  bodyRows.push({ key: 'Data', value: dateString });
  bodyRows.push({ key: 'Orario', value: hourDateString });
  if (data.route) {
    bodyRows.push({ key: 'Tratta', value: data.route });
  }
  if (!!data.subtype) {
    const subtypeLabel = data.subtype.label;
    const subtypePrice = data.subtype.price;
    bodyRows.push({ key: 'Trattamento', value: subtypeLabel });
    bodyRows.push({ key: 'Prezzo', value: subtypePrice });
  }
  if (data.genre) {
    const genre = data.genre === 1 ? 'donna' : 'uomo';
    bodyRows.push({ key: 'Genere', value: genre });
  }
  // if (route === 'navetta') {
  //   bodyRows.push({ key: '', value: 'Vuoi confermare la prenotazione?' });
  //   console.log(data);
  // }
  let alertText = '';
  for (const row of bodyRows) {
    alertText += `<div><span>${row.key}: </span> <span> ${row.value}</span></div>`;
  }
  return {
    title: alertTitle,
    text: alertText
  };
}
</script>
<style lang="scss" scoped>
.reservations {
  position: relative;
  &.open-alert {
    overflow: hidden;
  }
}
$common-margin: 21px;
.reservation-img {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  &.navetta-img {
    background-image: url('../assets/images/reservations/life_background_navetta.jpg');
  }
  &.beauty-img {
    background-image: url('../assets/images/reservations/life_beauty_v1.jpg');
  }
  &.barbecue-img {
    background-image: url('../assets/images/reservations/life_background_barbecue.jpg');
  }
  &.palestra-img {
    background-image: url('../assets/images/reservations/life_palestra_v1.jpg');
  }
  &.bike-img {
    background-image: url('../assets/images/reservations/life_bike_v1.jpg');
    background-position: center center;
  }
}

.reservation-calendar-body {
  position: relative;
  top: -32px;
}

.rds-reservation {
  padding: 0 $common-margin;
  margin-top: 9px;
}
h4 {
  text-align: center;
  font-weight: 600;
  background-color: #ffffff;
  border-radius: $default-border-radius;
  margin: 0;
  margin: 0 $common-margin;
  padding: 20px 0;
  letter-spacing: 1px;
  & /deep/ span {
    color: #c12828;
  }
}
.navetta-notifications-container,
.navetta-overlay,
.navetta-notifications {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.navetta-overlay {
  opacity: 0.76;
  background-color: #000000;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 150%;
}
</style>
